// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Activities_wrapper__-66wg","root":"Activities_root__3E1oJ"};